(function () {
  'use strict';
  if (window.MuShopLook) {
    window.MuShopLook.init(document);
    return;
  }

  function init(root) {
    root.querySelectorAll('[data-mu-shop-look]').forEach(function (section) {
      if (section.dataset.muShopLookReady === 'true') return;
      var carousel = section.querySelector('[data-mu-look-carousel]');
      var pins = Array.prototype.slice.call(section.querySelectorAll('[data-mu-look-pin]'));
      if (!carousel || !pins.length) return;
      section.dataset.muShopLookReady = 'true';

      function activate(index) {
        pins.forEach(function (pin, pinIndex) {
          var active = pinIndex === index;
          pin.classList.toggle('is-active', active);
          pin.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      function select(index) {
        activate(index);
        var slider = window.jQuery_T4NT && window.jQuery_T4NT(carousel).data('flickityt4s');
        if (slider) {
          slider.select(index);
        } else {
          carousel.scrollTo({ left: carousel.clientWidth * index, behavior: 'smooth' });
        }
      }

      pins.forEach(function (pin, index) {
        pin.addEventListener('click', function () { select(index); });
      });
      if (window.jQuery_T4NT) {
        window.jQuery_T4NT(carousel).on('change.flickityt4s.muShopLook', function (event, index) { activate(index); });
      }
      section.addEventListener('shopify:block:select', function (event) {
        pins.forEach(function (pin, index) {
          if (event.detail && pin.dataset.muLookBlock === event.detail.blockId) select(index);
        });
      });
    });
  }

  window.MuShopLook = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
